import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import Seo from "../components/Seo";
import Hero from "../sections/Hero";
import Marquee from "../components/Marquee";
import ClarityProblem from "../sections/ClarityProblem";
import BeforeAfter from "../components/BeforeAfter";
import StoryDiagnostic from "../sections/StoryDiagnostic";
import Method from "../sections/Method";
import Discovery from "../sections/Discovery";
import FeaturedProject from "../sections/FeaturedProject";
import Services from "../sections/Services";
import SignatureSales from "../sections/SignatureSales";
import Pricing from "../sections/Pricing";
import ComparisonTable from "../sections/ComparisonTable";
import WhySignature from "../sections/WhySignature";
import WebsiteCare from "../sections/WebsiteCare";
import About from "../sections/About";
import CtaBanner from "../sections/CtaBanner";
import { LogoMark } from "../components/Logo";
import { EASE } from "../components/Reveal";

let introPlayed = false;

export default function Home() {
  const [showIntro] = useState(!introPlayed);
  const [introGone, setIntroGone] = useState(introPlayed);

  useEffect(() => {
    introPlayed = true;
  }, []);

  const d = showIntro ? 0.9 : 0;

  return (
    <main data-testid="home-page">
      <Seo
        title="AT DIGITAL | Strategy • Story • Design • Technology"
        description="AT Digital helps businesses uncover what makes them valuable, communicate it clearly, and turn that story into a digital experience customers can understand, trust and act on."
      />
      {showIntro && !introGone && (
        <motion.div
          data-testid="intro-curtain"
          className="fixed inset-0 z-[100] flex items-center justify-center bg-ink"
          initial={{ y: 0 }}
          animate={{ y: "-100%" }}
          transition={{ duration: 0.85, delay: 0.85, ease: EASE }}
          onAnimationComplete={() => setIntroGone(true)}
        >
          <motion.div
            initial={{ opacity: 0, scale: 0.85 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.6, ease: EASE }}
          >
            <LogoMark className="h-16 w-16" />
          </motion.div>
        </motion.div>
      )}
      <Hero introDelay={d} />
      <Marquee />
      <ClarityProblem />
      <BeforeAfter />
      <StoryDiagnostic />
      <Method />
      <Discovery />
      <FeaturedProject />
      <Services />
      <SignatureSales />
      <Pricing />
      <ComparisonTable />
      <WhySignature />
      <WebsiteCare />
      <About />
      <CtaBanner />
    </main>
  );
}
